import isEqual from 'lodash.isequal'
import getDistance from 'geolib/es/getDistance'

export const checkIfMapStateHasChangedSubstantially = (oldState, newState) => {
  return !(
    isEqual(newState.size, oldState.size) &&
    isEqual(newState.bounds, oldState.bounds) &&
    newState.zoom === oldState.zoom &&
    getDistance(newState.center, oldState.center) < 15
  )
}
